<ng-container *ngIf="wrapBody; else body">
  <rt-dropdown *ngIf="stateName !== 'EMPTY_STATE'" [style.minHeight]="minHeight">
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </rt-dropdown>
</ng-container>

<ng-template #body>
  <ng-container *ngIf="suggestionsToDisplay.length > 0">
    <div rtScrollable (reachEnd)="onReachEnd()" [style.maxHeight]="maxHeight">
      <ng-container *ngFor="let suggestion of suggestionsToDisplay; trackBy: trackSuggestion">
        <ng-container
          *ngTemplateOutlet="
            suggestionItemTemplate || defaultSuggestionItem;
            context: {
              suggestion: suggestion,
              highlighted: highlighted,
              label: highlightValue(suggestion.value, stateValue),
              select: suggestionSelect.emit.bind(suggestionSelect)
            }
          "
        ></ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container
    *ngIf="stateName === 'LOADING_STATE'"
    [ngTemplateOutlet]="spinnerTemplate || spinner"
  ></ng-container>
</ng-template>

<ng-template #spinner>
  <rt-spinner variant="small"></rt-spinner>
</ng-template>

<ng-template
  #defaultSuggestionItem
  let-highlighted="highlighted"
  let-suggestion="suggestion"
  let-label="label"
  let-select="select"
>
  <rt-dropdown-item [highlighted]="suggestion.id === highlighted" (click)="select(suggestion)">
    <div [innerHTML]="label"></div>
  </rt-dropdown-item>
</ng-template>
